export default "__VITE_ASSET__BFHmImmp__"